import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    visibleAssetsMarkersSelector,
    detailViewSelector, removeDetailView,
    getAllVehiclesAsRack,
} from '../../../features/assets/assetsSlice';
import { setNeedBounding } from '../../../features/map/mapSlice';

const GoogleMapBounder = ({ map }) => {
    const dispatch = useDispatch();
    const visibleAssetMarkers = useSelector(visibleAssetsMarkersSelector);
    const focusedAsset = useSelector(detailViewSelector);
    const rack = useSelector(getAllVehiclesAsRack);

    useEffect(() => {
        const mapBounder = () => {
            if (map && !focusedAsset && visibleAssetMarkers.length > 0) {
                let bounds = new window.google.maps.LatLngBounds();
                visibleAssetMarkers.forEach((assetId) => {
                    const assetData = rack[`${assetId}`]
                    if (assetData.coreData) {
                        let point = new window.google.maps.LatLng(assetData.coreData.lat, assetData.coreData.lng);
                        bounds.extend(point);
                    }
                });
                map.fitBounds(bounds, { left: 350, bottom: 100, top: 75, right: 25 });
                dispatch(setNeedBounding(false));
            }
        };

        dispatch(removeDetailView());
        mapBounder();
    }, [visibleAssetMarkers, dispatch, focusedAsset, map, rack]);

    return (
        <div></div>
    );
}

export default GoogleMapBounder;